import React from "react";
import { chairQuestions } from "../../data/content";
import { SectionCta } from "../SectionCta";
export function Story() {
  return <section className="w-full bg-white px-4 py-16 sm:py-20" data-id="element-253" data-mp="1niutlcaq7hhs">
      <div className="mx-auto max-w-2xl" data-id="element-254" data-mp="21je1mjf6ynjy">
        <h2 className="text-center font-serif text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-255" data-mp="21ico88apdoz2">
          From <span className="text-muted" data-id="element-256" data-mp="1whye8kpjk4ye">"I think I can handle this case…"</span>{" "}
          <em className="text-brand" data-id="element-257" data-mp="18v05683r3zai">to knowing exactly what to check before saying YES.</em>
        </h2>

        <div className="mt-8 space-y-4 text-[17px] leading-relaxed text-muted" data-id="element-258" data-mp="14upwuoshkwsh">
          <p data-id="element-259" data-mp="1il1o6lh8yrik">I created Implant Case Decision™ because I kept seeing the same problem.</p>
          <p data-id="element-260" data-mp="1dsiazpmh1yea">
            Dentists weren't necessarily lacking implant knowledge. They were struggling with something much more basic:{" "}
            <strong className="text-ink" data-id="element-261" data-mp="q1me4e35sd06">knowing whether a specific case was actually appropriate for them to take.</strong>
          </p>
          <p data-id="element-262" data-mp="hisr96p01oo6">A patient sits in the chair. The CBCT is on the screen. The patient wants an implant. And suddenly you're asking yourself:</p>
        </div>

        <ul className="mt-6 space-y-2.5" data-id="element-263" data-mp="mfawe7o8rp11">
          {chairQuestions.map(q => <li key={q} className="rounded-xl border-l-4 border-brand bg-brand-light px-4 py-3 font-serif text-lg font-bold italic text-ink" data-id="element-264" data-mp="r8m56ecm6fvl">
              "{q}"
            </li>)}
        </ul>

        <p className="mt-6 text-[17px] leading-relaxed text-muted" data-id="element-265" data-mp="3uqnk17gi0qv9">That's exactly the uncertainty this system was designed to address.</p>

        <div className="mt-10 rounded-3xl bg-navy p-6 text-center sm:p-8" data-id="element-266" data-mp="8huossu7lp7p">
          <p className="text-sm font-bold uppercase tracking-wide text-brand-light/80" data-id="element-267" data-mp="8jp7s1lx7795">The real problem isn't lack of knowledge</p>
          <p className="mt-3 font-serif text-2xl font-black leading-snug text-white sm:text-3xl" data-id="element-268" data-mp="1jxay3q3inew9">
            It's not having a <em className="text-[#5aa2ff]" data-id="element-269" data-mp="1nxlc9q1gpbm7">repeatable decision process.</em>
          </p>
          <p className="mt-4 text-base leading-relaxed text-white/80" data-id="element-270" data-mp="3kyhf89ik4sqq">
            Without one, every case can feel different. With one, you evaluate the same critical categories systematically before committing to treatment.
          </p>
        </div>

        <SectionCta label="I want a repeatable decision process" data-id="element-271" data-mp="3txl11l93zm8x" />
      </div>
    </section>;
}